import {OrderConditions, OrderForm} from '~/types/types';
import {Ref} from 'vue';
import {asyncComputed} from '@vueuse/core';
import {getPickupPoint} from '~/api/order';
import {getPageContent} from '~/api/content';

/**
 * Использовать только в orderStore.
 * Файл предназначен для разделения логики заказа и валидации сложных или динамических правил
 * @param orderForm
 */
const useOrderConditions = (orderForm: Ref<OrderForm>) => {
  const orderCreateContent = asyncComputed(async () => {
    return (await getPageContent('/personal/order/create')).blocks
  }, {}, { lazy: true })

  const orderCargoConditionHint = computed(() => {
    if (pickupPointCondition.value.cargo?.dimension?.general) {
      return orderCreateContent.value?.pickupPointInfo.hint
    }
    return ''
  })

  // Пункт выдачи заказа
  const pickupPointCondition = asyncComputed<OrderConditions>(async () => {
    if (orderForm.value.directions.destination.direction !== 'pickupPoint' || !orderForm.value.directions.destination.pickupPointGuid) {
      return {}
    }
    const content = orderCreateContent.value
    const pupConditions = (await getPickupPoint(orderForm.value.directions.destination.pickupPointGuid)).conditions || {}
    if (pupConditions.cargo?.dimension) {
      pupConditions.cargo.dimension.pallets = {
        disabled: true,
        reason: content?.pickupPointInfo.blockedHint
      }
      // Для пвз габариты общие
      if (pupConditions.cargo?.dimension?.general && pupConditions.cargo.dimension.detail) {
        pupConditions.cargo.dimension.general.volume = {
          '<=': (pupConditions.cargo.dimension.detail.length?.['<='] || 0) *
              (pupConditions.cargo.dimension.detail.width?.['<='] || 0) *
              (pupConditions.cargo.dimension.detail.height?.['<='] || 0)
        }
      }
    }
    pupConditions.additionalServices = {
      disabled: true,
      reason: content?.pickupPointInfo.blockedHint
    }
    return pupConditions
  }, {})

  const orderConditions = computed(() => {
    return {
      pickupPoint: pickupPointCondition.value
    }
  })

  const orderConditionValues = computed<OrderConditions>(() => {
    // если будет несколько источников условий, нужно будет высчитывать
    return Object.assign({}, ...Object.values(orderConditions.value))
  })


  return {
    orderConditionValues,
    orderCreateContent,
    orderCargoConditionHint
  }
}

export default useOrderConditions